'use client';

import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { useAutoplayOnInView } from '@/hooks/useAutoplayOnInView';
import { useSelectedSnapIndex } from '@/hooks/useSelectedSnapIndex';

interface EventBannerPagerProps {
  slides: { id: string; node: ReactNode }[];
}

//* 시안: PC는 한 장씩 넘기는 캐러셀, 모바일은 배너를 세로로 쌓은 목록
export const EventBannerPager = ({ slides }: EventBannerPagerProps) => {
  const [autoplayPlugin] = useState(() =>
    Autoplay({ delay: 3000, stopOnInteraction: false }),
  );
  const { ref: inViewRef, inView } = useInView({ threshold: 0.3 });
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: slides.length > 1 }, [
    autoplayPlugin,
  ]);
  const selectedIndex = useSelectedSnapIndex(emblaApi);

  useAutoplayOnInView(emblaApi, inView);

  return (
    <div className="w-full">
      <div ref={inViewRef} className="relative mobile-tablet:hidden">
        <div ref={emblaRef} className="overflow-hidden">
          {/* 루프에서 마지막→처음 사이에도 같은 간격이 나오도록 margin 대신 슬라이드 안쪽 padding으로 띄운다 */}
          <ul className="-ml-16 flex">
            {slides.map((slide, index) => (
              <li
                key={slide.id}
                aria-hidden={index === selectedIndex ? undefined : true}
                className="min-w-0 flex-[0_0_100%] pl-16"
              >
                {slide.node}
              </li>
            ))}
          </ul>
        </div>
        {slides.length > 1 ? (
          <span className="pointer-events-none absolute bottom-20 right-12 rounded-pill bg-Gray-black/35 px-12 py-4 font-500 text-Gray-white typo-caption1">
            {selectedIndex + 1} / {slides.length}
          </span>
        ) : null}
      </div>
      <ul className="hidden flex-col gap-16 mobile-tablet:flex">
        {slides.map((slide) => (
          <li key={slide.id}>{slide.node}</li>
        ))}
      </ul>
    </div>
  );
};
